import gql from 'graphql-tag';

export const CONTACT_REQUEST = gql`
	mutation ContactUsRequest($input: CustomerContactRequest!) {
		contactUsRequest(input: $input)
	}
`;
